function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 136,
  height: 136,
  fill: "#E5E5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -1148,
  y: -1151,
  width: 5329,
  height: 2562,
  stroke: "#2A9419",
  strokeWidth: 40
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6_657)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 900,
  transform: "translate(-652 -122)",
  fill: "#F2F3F4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_6_657)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -412,
  y: -52,
  width: 960,
  height: 532,
  rx: 5,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_6_657)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 68,
  r: 60,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_6_657)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.6647 87.7654C35.7316 87.5236 35.8139 87.2818 35.9168 87.0451C36.2717 86.2218 36.8119 85.4551 37.2543 84.6781C38.0104 83.3609 38.7615 82.0385 39.5176 80.7212C41.0248 78.0816 42.5372 75.4419 44.0444 72.8023C46.7141 68.1302 49.389 63.4632 52.0691 58.7962C56.2152 51.5771 60.387 44.3682 64.5536 37.1594C66.2615 34.2007 69.5639 33.1819 72.4189 34.6947C73.4117 35.2246 74.173 35.9965 74.7285 36.9638C78.6123 43.689 82.5012 50.4193 86.3798 57.1497C86.8787 58.0141 86.7347 58.7808 86.0454 59.2027C85.3407 59.6349 84.5794 59.3571 84.0495 58.4721C83.9466 58.3022 83.8489 58.1222 83.7512 57.9472C80.0372 51.5102 76.318 45.0731 72.6092 38.631C72.0639 37.6842 71.3695 36.9278 70.2275 36.7632C68.6894 36.5419 67.6092 37.216 66.8582 38.5281C64.8468 42.0322 62.8201 45.526 60.7985 49.0249C53.4425 61.7652 46.0917 74.5055 38.7409 87.2509C37.8458 88.7997 37.8612 90.0037 38.7923 91.1718C39.317 91.8355 40.0063 92.2112 40.8551 92.278C41.1226 92.2986 41.3901 92.3089 41.6575 92.3089C60.3561 92.3089 79.0547 92.3089 97.7532 92.3089C99.5536 92.3089 100.618 91.6503 101.138 90.2404C101.529 89.1804 101.236 88.2337 100.696 87.3075C97.7121 82.1465 94.7337 76.9856 91.7553 71.8195C91.0763 70.6412 90.387 69.4629 89.7131 68.2794C89.5794 68.0478 89.461 67.806 89.3839 67.5539C89.1987 66.9724 89.4508 66.355 89.96 66.0514C90.4744 65.7478 91.138 65.8198 91.5598 66.2624C91.7553 66.4682 91.9147 66.7203 92.0588 66.9724C95.6442 73.1779 99.2347 79.3783 102.789 85.5992C103.669 87.1377 104.332 88.7791 103.839 90.5492C103.077 93.2763 100.557 95 97.7789 95C79.0649 94.9794 60.3458 94.9897 41.6318 94.9897C41.3438 94.9897 41.0505 94.9846 40.7625 94.9691C37.2645 94.7685 34.7954 91.0483 35.675 87.7654H35.6647Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.9839 64.272C73.9839 66.2581 74.0148 68.2443 73.9788 70.2356C73.9119 73.6728 70.414 75.6744 67.4973 73.9455C66.1444 73.1428 65.4397 71.8925 65.4294 70.3385C65.3934 66.2736 65.3831 62.2086 65.4294 58.1488C65.4603 55.7253 67.3636 53.9089 69.7144 53.9141C72.0601 53.9192 73.9274 55.7459 73.9788 58.1746C74.0251 60.207 73.9891 62.2395 73.9891 64.272H73.9839ZM71.3039 64.2668C71.3039 62.3218 71.3142 60.382 71.3039 58.437C71.2988 57.3204 70.6455 56.6 69.6887 56.6052C68.737 56.6103 68.1043 57.3358 68.094 58.4576C68.0837 59.2397 68.094 60.0218 68.094 60.8039C68.094 63.8655 68.094 66.9271 68.094 69.9835C68.094 70.7862 68.3409 71.4448 69.128 71.769C70.2288 72.2166 71.2936 71.4088 71.3091 70.1018C71.3296 68.1568 71.3142 66.217 71.3142 64.272L71.3039 64.2668Z",
  fill: "#3F851E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.7094 86.3752C67.3586 86.3803 65.3987 84.4148 65.4142 82.0684C65.4296 79.7426 67.3637 77.8131 69.6888 77.8028C72.0345 77.7925 73.9995 79.7684 73.9841 82.1147C73.9687 84.4405 72.0345 86.37 69.7146 86.3752H69.7094ZM71.2938 82.0684C71.2784 81.2245 70.5325 80.4887 69.694 80.4887C68.8298 80.4887 68.0633 81.2863 68.0993 82.1404C68.1353 82.9894 68.8967 83.7098 69.73 83.6841C70.5685 83.6635 71.3092 82.8968 71.2938 82.0684Z",
  fill: "#3F851E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.9612 63.1439C86.9458 62.4081 87.5168 61.8164 88.2473 61.8009C88.9726 61.7906 89.5796 62.3721 89.595 63.0924C89.6104 63.8128 89.024 64.4148 88.2987 64.4303C87.5631 64.4457 86.9715 63.8797 86.9612 63.1439Z",
  fill: "#B7E3A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.8281 42.1733C90.8281 42.2904 90.8538 42.4074 90.9115 42.5114C91.5654 43.4474 92.4052 44.2469 93.3861 44.8644C93.8541 45.1569 94.3349 44.9294 94.6811 44.5589C95.0529 44.1429 95.1298 43.6359 94.7452 43.2199C94.0913 42.5049 93.3861 41.8288 92.6552 41.2048C92.3155 40.9058 91.8475 40.9058 91.4308 41.1463C91.2384 41.2438 91.091 41.3998 90.982 41.5818C90.8794 41.7638 90.8281 41.9653 90.8409 42.1798H90.8345L90.8281 42.1733Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.5147 37.0404C85.5339 37.3589 85.675 37.6579 85.9122 37.8789C86.4635 38.4119 87.0085 38.9384 87.579 39.4714C88.1496 40.0044 88.8356 39.9849 89.3036 39.5299C89.778 39.0749 89.7716 38.3989 89.2459 37.8789C88.6753 37.3004 88.0855 36.7414 87.4893 36.1888C87.329 36.0263 87.111 35.9158 86.8738 35.8898C86.643 35.8508 86.3994 35.8898 86.1879 35.9938C85.9763 36.0783 85.8096 36.2278 85.6814 36.4163C85.5596 36.5984 85.5019 36.8194 85.5083 37.0339H85.5147V37.0404Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.5093 40.9961C88.3362 40.9961 88.1695 41.0221 88.0029 41.0936C87.8426 41.1586 87.7015 41.2561 87.5861 41.3861C87.0348 41.9191 86.4706 42.4391 85.9321 42.9851C85.3936 43.5312 85.4064 44.1877 85.8873 44.6362C86.3617 45.0912 87.0412 45.0912 87.599 44.5712C88.1631 44.0512 88.7401 43.4922 89.3043 42.9331C89.4838 42.7706 89.5992 42.5561 89.6376 42.3286C89.6761 42.0946 89.6376 41.8541 89.5351 41.6526C89.4517 41.4576 89.3043 41.2951 89.1248 41.1716C88.9453 41.0546 88.7273 40.9961 88.5093 40.9961H88.5157H88.5093Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.8477 38.7422C90.8477 38.9567 90.9118 39.1582 91.04 39.3337C91.1618 39.5093 91.3349 39.6523 91.5336 39.7368C91.9632 39.9123 92.4183 39.9123 92.7581 39.6003C93.4313 39.0087 94.0788 38.3847 94.6878 37.7282C95.1045 37.2732 95.0468 36.7467 94.6301 36.2917C94.2583 35.8887 93.5531 35.7586 93.1364 36.1292C92.3927 36.7532 91.7195 37.4422 91.0464 38.1247C90.9695 38.2092 90.9118 38.3067 90.8861 38.4172C90.8477 38.5212 90.8412 38.6382 90.8605 38.7422H90.8541H90.8477Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9877 78.648C30.9877 78.3165 31.0046 77.985 30.9877 77.6534C30.9877 77.4174 30.881 77.1927 30.7125 77.0297C30.5327 76.8611 30.3024 76.7656 30.0609 76.7656C29.5384 76.7656 29.1227 77.0072 29.0497 77.5073C28.9261 78.2715 28.9261 79.047 29.0497 79.8168C29.1284 80.3169 29.6002 80.5978 30.1339 80.5248C30.6563 80.463 30.9653 80.1427 30.999 79.637C31.0158 79.3167 30.999 78.9852 30.999 78.6536H30.9934L30.9877 78.648Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9773 82.4282C27.3481 82.4282 27.7188 82.4507 28.084 82.4282C28.3199 82.4226 28.5446 82.3215 28.7131 82.1698C28.8817 82.0068 28.9772 81.7989 28.9884 81.5797C29.0221 81.0797 28.7244 80.6526 28.1795 80.5852C27.3874 80.4897 26.5897 80.4953 25.7977 80.5852C25.264 80.6582 25.0056 81.0291 25 81.5292C25 81.7652 25.1067 81.9899 25.2753 82.1529C25.4438 82.3158 25.6797 82.417 25.9269 82.417C26.2752 82.4395 26.6291 82.417 26.9773 82.417V82.4282Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.0154 82.4314C33.3862 82.4314 33.7569 82.4539 34.1277 82.4314C34.3524 82.4314 34.5715 82.3359 34.7344 82.1786C34.8973 82.0268 34.9872 81.8133 34.9928 81.5998C35.0433 81.0885 34.8018 80.6951 34.2681 80.6165C33.4367 80.4872 32.5885 80.4872 31.7571 80.6165C31.2403 80.6951 31.0156 81.0828 31.0156 81.5548C31.0156 81.7796 31.1111 81.9987 31.274 82.1617C31.4369 82.3247 31.6616 82.4202 31.9032 82.437C32.2739 82.4708 32.6447 82.437 33.0154 82.437V82.4314Z",
  fill: "#273950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9949 84.3398C30.9949 84.0082 31.0118 83.6711 30.9949 83.3396C30.9612 82.817 30.6298 82.5304 30.1074 82.4574C29.8714 82.4237 29.6299 82.4742 29.4389 82.6091C29.2479 82.7383 29.1187 82.9406 29.0738 83.1654C28.939 83.9577 28.939 84.7556 29.0738 85.5479C29.0962 85.6602 29.1356 85.767 29.203 85.8569C29.2648 85.9524 29.349 86.0367 29.4445 86.0985C29.54 86.1603 29.6524 86.2053 29.7647 86.2278C29.8771 86.2502 30.0006 86.2502 30.1186 86.2278C30.6523 86.1547 30.9556 85.8569 30.9893 85.34C31.0062 85.0084 30.9893 84.6713 30.9893 84.3398H30.9949Z",
  fill: "#273950"
})));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_6_657",
  x: -416,
  y: -56,
  width: 970,
  height: 542,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.356863 0 0 0 0 0.403922 0 0 0 0 0.439216 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6_657"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6_657",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_6_657",
  x: 0,
  y: 0,
  width: 136,
  height: 136,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6_657"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6_657",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6_657"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 900,
  fill: "white",
  transform: "translate(-652 -122)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_6_657"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 61,
  fill: "white",
  transform: "translate(24 34)"
})));

var SvgReAttempt = function SvgReAttempt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReAttempt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reAttempt.84fcda28.svg";
export { ForwardRef as ReactComponent };